import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const HeaderWrapper = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2em 0;
  color: white;
  width: 100%; /* Assicura che l'header occupi al massimo il 100% */
  box-sizing: border-box;

    @media (max-width: 768px) {
    padding: 1em 0 2em;
  }
`;

export const HamburgerButton = styled.button`
  font-size: 1.5rem;
  background: none;
  border: none;
  color: white;
  cursor: pointer;

  @media (min-width: 768px) {
    display: none; /* Nascondi il pulsante hamburger su desktop */
  }
`;

export const Drawer = styled.div`
  position: fixed;
  top: 0;
  left: ${(props) => (props.open ? '0' : '-100%')}; /* Nasconde completamente il drawer */
  height: 100%;
  width: 300px;
  background-color: #ffffff;
  color: black;
  display: flex;
  flex-direction: column;
  transition: left 0.3s ease-in-out;
  z-index: 1001;

  @media (min-width: 768px) {
    display: none; /* Nascondi il drawer su desktop */
  }
`;

export const DrawerMenu = styled.div`
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  padding: 1.5rem 1.5rem 0rem 1.5rem;
`;

// export const MenuLink = styled.a`
//   color: black;
//   text-decoration: none;
//   margin: 0.5rem 0;
//   font-size: 1rem;
//   cursor: pointer;

//   &:hover {
//     color: #0056b3;
//   }
// `;

export const DrawerOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
`;

// Stili per la navbar desktop
export const Navbar = styled.nav`
  display: none;

  @media (min-width: 768px) {
    display: flex;
    gap: 1.5rem;
  }
`;

export const NavItem = styled.div`
    position: relative;

`;

export const NavLink = styled(Link)`
    text-decoration: none;
    color: #262626;
    padding: 0.5em 1em;
    word-wrap: break-word;
    white-space: normal;
    &:hover {
        color: #CC0000;
    }
`;

export const DropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  background-color: #ffffff;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 100;
  min-width: 150px;
  ${({ show }) => (show ? 'display: block;' : 'display: none;')}
`;

export const DropdownItem = styled(Link)`
    display: block;
    padding: 10px 15px;
    text-decoration: none;
    color: #262626;
    &:hover {
        color: #CC0000;
        background-color: #f0f0f0;
    }
`;

export const Divider = styled.div`
  height: 30px;
  width: 1px;
  background-color: black;
  margin: 0 10px;
`;

export const HorizontalDivider = styled.div`
  height: 1px;
  width: 100%;
  background-color: #E9EDF0;
  margin: 10px 0px 10px;
`;

